import React, { useState, useContext } from "react";
import SimpleBar from 'simplebar-react';
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../scss/main.scss';
import { faKey, faUserFriends, faChartPie, faSignOutAlt, faTimes, faInbox, faSearch, faAdd, faUser, faTasks, faFolderOpen, faLockOpen } from "@fortawesome/free-solid-svg-icons";
import { Nav, Badge, Image, Button, Dropdown, Accordion, Navbar } from '@themesberg/react-bootstrap';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Auth } from "aws-amplify";
import { ProductContext } from "../ProductProvider";
import { Routes } from "../routes";
import mdulogo from "../assets/img/mdulogo.png";
import ProfilePicture from "../assets/img/team/profile-picture-3.jpg";
import { faFirstdraft } from "@fortawesome/free-brands-svg-icons";

export default (props = {}) => {
  const history=useHistory();
  const location = useLocation();
  const { loggedUser, setLoggedUser, resetValues } = useContext(ProductContext);
  const { pathname } = location;
  const [show, setShow] = useState(false);
  const showClass = show ? "show" : "";

  const onCollapse = () => setShow(!show);

  const handleResetValues=()=>{
    resetValues()
  }

  const handleRouteMDUProvince =(event)=>{
    event.preventDefault();
   // console.log("Clicked");
    window.location.href = "https://mdusj.org/"
  }

  const handleSignOut=async()=>{
    try{
      await Auth.signOut()
      .then((res)=>{
        setLoggedUser({...loggedUser,
          name:'',
          email:'',
         // currentStatus:'',
          DOB:'',
          profile:'',
          provinceName:'',
          website:'',
          isAuthenticated:false
        }); 
        history.push(Routes.Signin.path);

      }).catch((error)=>{
        console.log("Error ", error.message);
      })
    }catch(error){
      console.log("Error ", error.message);
    }
  }

  const CollapsableNavItem = (props) => {
    const { eventKey, title, icon,  children = null } = props;
    const defaultKey = pathname.indexOf(eventKey) !== -1 ? eventKey : "";

    return (
      <Accordion as={Nav.Item} defaultActiveKey={defaultKey}>
        <Accordion.Item eventKey={eventKey} style={{backgroundColor:'#262B40'}} >
          <Accordion.Button as={Nav.Link} className="d-flex justify-content-between align-items-center" style={{backgroundColor:'#262B40'}}>
            <span>
              <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span>
              <span className="sidebar-text">{title}</span>
            </span>
          </Accordion.Button>
          <Accordion.Body className="multi-level">
            <Nav className="flex-column" >
              {children}
            </Nav>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  };

  const NavItem = (props) => {
    const { title, link, external, target, icon, image, badgeText, badgeBg = "secondary", badgeColor = "primary" } = props;
    const classNames = badgeText ? "d-flex justify-content-start align-items-center justify-content-between" : "";
    const navItemClassName = link === pathname ? "active" : "";
    const linkProps = external ? { href: link } : { as: Link, to: link };

    return (
      <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
        <Nav.Link {...linkProps} target={target} className={classNames}>
          <span>
            {icon ? <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span> : null}
            {image ? <Image src={image} width={20} height={20} className="sidebar-icon svg-icon" /> : null}

            <span className="sidebar-text">{title}</span>
          </span>
          {badgeText ? (
            <Badge pill bg={badgeBg} text={badgeColor} className="badge-md notification-count ms-2">{badgeText}</Badge>
          ) : null}
        </Nav.Link>
      </Nav.Item>
    );
  };

  return (
    <>
      <Navbar expand={false} collapseOnSelect variant="dark" className="navbar-theme-primary px-4 d-md-none">
        <Navbar.Brand className="me-lg-5" as={Link} to="https://mdusj.org">
          <Image src={mdulogo} className="navbar-brand-light" />
        </Navbar.Brand>
        <Navbar.Toggle as={Button} aria-controls="main-navbar" onClick={onCollapse}>
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>
      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar className={`collapse ${showClass} sidebar d-md-block bg-primary text-white`}>
          <div className="sidebar-inner px-4 pt-3">
            <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
              <div className="d-flex align-items-center">
                <div className="user-avatar lg-avatar me-4">
                  <Image src={ProfilePicture} className="card-img-top rounded-circle border-white" />
                </div>
                <div className="d-block">
                  <h6>Hi, {loggedUser.name}</h6>
                  <Button as={Link} variant="secondary" size="xs" to={Routes.Signin.path} className="text-dark" onClick={handleSignOut}>
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Sign Out
                  </Button>
                </div>
              </div>
              <Nav.Link className="collapse-close d-md-none" onClick={onCollapse}>
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>
            <Nav className="flex-column pt-3 pt-md-0">
              <a href="https://mdusj.org"><img src={mdulogo} style={{width:"50px", height:"50px"}} />  Madurai Province</a>
             {/*} <NavItem title="Madurai Province" link="#"  onClick={(event)=>handleRouteMDUProvince(event)} image={mdulogo}/>*/}
              <NavItem title="Online Catalogue" link={Routes.DashboardOverview.path} icon={faChartPie} />
              <Dropdown.Divider className="my-3 border-indigo" />
              <NavItem title="My Profile" link={Routes.MyProfileView.path} badgeText="New" icon={faUser} />
              <Dropdown.Divider className="my-3 border-indigo" />
              {loggedUser.isAdmin?<CollapsableNavItem eventKey="member/" title="Member" icon={faUserFriends}>
              {loggedUser.isAdmin? <NavItem title="Add Member" icon={faAdd} link={Routes.AddMember.path} onClick={handleResetValues} />:null}
              {loggedUser.isAdmin?<NavItem title="Search" icon={faSearch} link={Routes.UserSearch.path} />:null}
              {loggedUser.isAdmin?<NavItem title="Login Accounts" icon={faLockOpen} link={Routes.LoginAccount.path} />:null}
              </CollapsableNavItem>:null}             
              <CollapsableNavItem eventKey="request/" title="Request" icon={faInbox}>
              <NavItem title="New Request" icon={faFirstdraft} link={Routes.UserRequest.path} />
              <NavItem title="My Request" icon={faTasks} link={Routes.TaskList.path} />
             {loggedUser.isAdmin? <NavItem title="Open Request" icon={faFolderOpen} link={Routes.OpenList.path} />:null}
             </CollapsableNavItem>
              <Dropdown.Divider className="my-3 border-indigo" />
              <NavItem title="Change Password" link={Routes.ResetPassword.path} icon={faKey} />
              <Button as={Link} to="#" variant="secondary" className="upgrade-to-pro" onClick={handleSignOut}><FontAwesomeIcon icon={faSignOutAlt} className="me-1" /> Log Out</Button>
            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
};
